import React, { useEffect, useState } from 'react'
import {Link} from 'react-router-dom'
import BackendUserApi from './../../../api/BackendUserApi'
import Pagination from './../../../components/Paginate'

function UserPage() {
    const [search, setSearch] = useState('')
    const [state, setState] = useState({
        params: {
            search: '',
            page: 1
        },
        items: [],
        metadata: {}
    })

    useEffect(() => {
        (async() => {
            let { docs, ...rest } = await BackendUserApi.query(state.params)
            setState(state => ({
                ...state,
                items: docs,
                metadata: rest
            }))
        })()
    }, [state.params])

    const onSearch = (e) => {
        e.preventDefault()
        setState(state => ({
            ...state,
            params: {
                ...state.params,
                search,
            }
        }))
    }

    const pageChange = (p) => {
        setState(state => ({
            ...state,
            params: {
                ...state.params,
                page: p,
            }
        }))
    }

    return (
        <div className="card">
            <div className="card-body">
                <div className="row form-group">
                    <div className="col-sm-5">
                        <form onSubmit={onSearch}>
                            <input type="text" className="form-control" placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)}/>
                        </form>
                    </div>
                    <div className="col-sm-7 text-right">
                        <Link className="btn btn-primary" to={{pathname:`/backusers/create`, state: {title: 'Create User'}}}>
                            <i className="fa fa-user-plus"></i> Create User
                        </Link>
                    </div>
                </div>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>UID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            state.items && state.items.length > 0 && state.items.map(user => {
                                return (
                                    <tr key={user.id}>
                                        <td>{user.id}</td>
                                        <td>{user.name}</td>
                                        <td>{user.email}</td>
                                        <td>{user.role}</td>
                                        <td>
                                            <div className="btn-group">
                                                <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    Action <span className="caret"></span>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li>
                                                        <Link to={{pathname:`/backusers/${user.id}`, state: {title: 'Edit Backend User'}}}><i className="fa fa-pencil"></i> Edit</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                            
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                <Pagination 
                    currentPage={state.metadata.currentPage || 1}
                    pageCount={state.metadata.totalPages || 1}
                    rowCount={10}
                    itemTotal={state.metadata.totalItems || 1}
                    onPageChange={(n) => pageChange(n)}
                />
            </div>
        </div>
    )
}


export default UserPage
